<template>
<div class="pp-loading-indicator">
    <div class="pp-loading-indicator__icon">
        <i class="fa fa-fw fa-refresh"></i>
    </div>
</div>
</template>


<script>
export default {
    name: 'loading-indicator'
};
</script>



// WEBPACK FOOTER //
// LoadingIndicator.vue?46820e84